module.exports = __webpack_public_path__ + "media/27.b87c2f23.mp3";